module.exports = __webpack_public_path__ + "assets/images/ab35d403f3da9fea9629fbc81c530822.png";